import { useContext } from 'react';
import { HttpContext } from "../HttpContext";

export function useAddressService() {
  const { httpClient } = useContext(HttpContext);

  const getAddress = async (value) => {
    if (value.length > 1) {
      return httpClient.get(`/address/${value}`).then(promise => promise.data)
    }
  }

  return {getAddress}
}
